import { sel } from "../../academy/selectors";
import { TutorialDefinition } from "../types";

/**
 * Academy lesson: regenerate the narrative. Started from the lesson page in a
 * new tab; never auto-started. It only shows the controls and never clicks
 * Confirm, so nobody loses edits by finishing the walkthrough.
 */
const tour: TutorialDefinition = {
  id: "regenerate-the-narrative",
  version: "1.0.0",
  releasedAt: "2026-10-29T00:00:00.000Z",
  category: "onboarding",
  title: "Regenerate",
  description: "Rewrite the whole narrative from the current transcript.",
  triggerRoute: /^\/cases(\/.*)?$/,
  startRoute: "/cases",
  lessonId: "regenerate-the-narrative",
  autoStart: false,
  steps: [
    {
      target: sel("caseListItem"),
      title: "Open a report from audio",
      content: "Click a report that was made from a recording. Regenerate needs a transcript to work from.",
      disableBeacon: true,
      placement: "right",
      advanceOn: { selector: sel("caseListItem"), event: "click" },
      hint: "Open a report to continue",
      spotlightClicks: true,
    },
    {
      target: sel("editorTabNarrative"),
      waitFor: sel("editorTabNarrative"),
      waitTimeoutMs: 10000,
      title: "The Narrative tab",
      content: "With the Narrative tab selected, click it again to open its dropdown.",
      disableBeacon: true,
      placement: "bottom",
      advanceOn: { selector: sel("editorTabNarrative"), event: "click" },
      hint: "Click the Narrative tab",
      spotlightClicks: true,
    },
    {
      target: sel("regenerateNarrative"),
      waitFor: sel("regenerateNarrative"),
      title: "Regenerate Narrative",
      content:
        "This rewrites the whole draft from the transcript with your current preferences. A dialog asks you to confirm first, because manual edits are lost. We will stop here.",
      disableBeacon: true,
      placement: "bottom",
    },
    {
      target: sel("editorTabTranscription"),
      waitFor: sel("editorTabTranscription"),
      title: "Fix the inputs first",
      content: "Correct the transcript and name the speakers on the Transcription tab before you regenerate.",
      disableBeacon: true,
      placement: "bottom",
    },
  ],
};

export default tour;
